module.exports = __webpack_public_path__ + "static/media/gabriel_1.5abc64f3.png";